import GET_ARTICLES from "../plugins/getArticles"
import GOOGLEMAP from "../plugins/googlemap"

const [ w, d, l ] = [ window, document, location ]

const is_about = id => {
  let param
  if( l.search != "" && /mode=detail/.test( l.search ) ){
    param = parseInt( l.search.match(/^\?mode=detail&article=([\d]+)/)[1] )
  }
  if( l.search == "" ){
    param = 1
  }
  return param == id
}

const aboutus01_init = () => {
  let makeItem = item => {
    let data = item.desc.split('|')
    let name = data[0].replace(/^\s|\s$/m,'').replace(/(.+)\s(.+)/,'$1<br>$2')
    let sex = data[2].replace(/^\s|\s$/m,'') || ''
    return $(`
      <a href="${item.href}" class="p-block-members-item is-${sex}">
        <figure class="p-block-members-item__cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="200" height="200"></figure>
        <div class="p-block-members-item__body"><h4>${name}</h4></div>
      </a>
    `)[0]
  }
  let getMember = GET_ARTICLES('.p-block-members__list[data-plugin="getArticles"]', { makeItem })
  getMember.then( () => {
    let $list = $('.p-block-members__list')
    let slickOpt = {
      dots: false,
      centerMode: true,
      variableWidth: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      centerPadding: 0,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 1000
    }
    if( $list.children('a').length == 0 ) return false
    if( $list.children('a').length < 4 ) $list.children('a').clone( true ).appendTo( $list )
    $list.slick( slickOpt )
  })
}

const aboutus02_init = () => {
  w.load['mapScript'].done( GOOGLEMAP )
}
const aboutus03_init = () => {
  w.load['mapScript'].done( GOOGLEMAP )
}

const about_member_init = ( data = false ) => {

  // 一覧・詳細共通設定
  $('.element_list').addClass('member-list')
  $('.element_detail').addClass('member-detail')

  // 一覧用設定
  $('.list_title1','.element_list').replaceWith($(`
    <h3 class="member-title">
      <span>MEMBERS</span>
      <small>スタッフ一覧</small>
    </h3>
  `))
  $('.contents .wrapLink','.element_list').each( (i,obj) => {
    let href = obj.getAttribute('href')
    let thumb = obj.querySelector('.thum_img > img').getAttribute('src')
    let title = obj.querySelector('h5 > a').getAttribute('title')
    let desc = obj.querySelector('p.catch').innerText.split('|')
    let name = desc[0].replace(/^\s|\s$/m,'').replace(/(.+)\s(.+)/,'$1<br>$2')
    let position = desc[1].replace(/^\s|\s$/m,'').replace(/(.+),(.+)/,'$1<br>$2')
    let sex = desc[2].replace(/^\s|\s$/m,'') || ''
    let $item = $(`
      <a href="${href}" class="member-item is-${sex}" data-lazydisp="bottom">
        <figure class="member-item__img">
          <div class="member-item__img-cover"><img src="${thumb}" alt="${title} ${name}" width=""></div>
        </figure>
        <div class="member-item__body">
          <p class="position">${position}</p>
          <h4 class="name">${title}</h4>
        </div>
      </a>`)
    $(obj).replaceWith( $item )
  })

  // 詳細設定
  $('.member-detail').each( (i,obj) => {
    if( data ){
      let desc = data[0].desc.split('|')
      let name = desc[0].replace(/^\s|\s$/m,'').replace(/(.+)\s(.+)/,'$1 $2')
      let position = desc[1].replace(/^\s|\s$/m,'').replace(/(.+),(.+)/,'$1<br>$2')
      let sex = desc[2].replace(/^\s|\s$/m,'') || ''
      let $btn = $(`
        <div class="member-detail__btnwrap">
          <a href="/aboutus/?mode=list&cat=2" class="button button-border">スタッフ一覧へ</a>
        </div>
      `)
      $('.block_foot').remove()
      $('.entry').wrapInner('<div class="member-detail__inner">')
      $('.entry .member-detail__inner > .imgbox').prependTo('.entry') // .imgboxと.member-detail__innerを兄弟要素に
      $(`
        <p class="member-detail__signature">
          <small class="position">${position}</small>
          <strong class="name">${data[0].title}</strong>
          <small class="name-en">${name}</small>
        </p>
      `).appendTo('.entry > figure.imgbox')
      $btn.clone(true).appendTo('.imgbox')
      $btn.clone(true).appendTo('.entry')
    }
  })
}

const detail_init = async () => {
  let data = await $.getJSON('/asset/api/getArticles/',{
    content: 'aboutus',
    post_id: w.query_string('article')
  })

  // member detailだったら
  if( parseInt( data[0].category ) == 2 ) about_member_init( data )
}

const init = () => {
  // map script
  const km = w.siteinfo.mapApiKeys
  const env_map_key = (!km[l.host]) ? km['local'] : km[l.host]

  if( is_about(2) || is_about(3) ){
    w.addScript({src:`https://maps.googleapis.com/maps/api/js?v=3&key=${env_map_key}&callback=load.mapScript.resolve`})
  }

  if( is_about(1) ){
    // aboutus01_init()
    w.load['aboutus-01'].done( aboutus01_init )
  }
  if( is_about(2) ){
    // aboutus02_init()
    w.load['aboutus-02'].done( aboutus02_init )
  }
  if( is_about(3) ){
    // aboutus02_init()
    w.load['aboutus-03'].done( aboutus03_init )
  }

  if( w.query_string('mode') == 'list' && w.query_string('cat') == 2 ){
    about_member_init()
  }
  if( w.query_string('article') > 3 ){
    detail_init()
  }

  $(() => {
    w.load['loadHtml'].done(() => {
      $('[data-plugin="currentMenu"]').currentMenu({mode:0,default:999})
    })
  })
}

export default function ABOUTUS() {
  $(() => init() )
}